export const $ = function(className) {
    let condition = arguments.length > 1 ? arguments[1] : true
    return !!condition && className
}
export const $$$ = (...args) => args.filter(Boolean).join(' ')
